import type { TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import SettingsCentralMappingDropdownsDropdownMapping from 'lumen/components/settings/central-mapping/dropdowns/dropdown-mapping';
import { TRIGGER_CENTRAL_MAPPING_VARIANTS } from 'lumen/components/settings/central-mapping/dropdowns/triggers/trigger-central-mapping';
import type { CentralMappingCategory } from 'lumen/models';
import type { CentralMappingMappingEntryExtendedModel } from 'lumen/utils/central-mapping-constants';

interface HotelSettingsCentralMappingTablesCellsTdMappingSignature {
  Args: {
    column: {
      hierarchyCategories: CentralMappingCategory[];
      isReadOnly?: boolean;
    };
    row: {
      mappingEntry: CentralMappingMappingEntryExtendedModel;
      onOverrideAutomapping?: () => void;
      setCategory: (category: CentralMappingCategory | null) => void;
      toggleAutomapping: (category: CentralMappingCategory | null) => void;
    };
    rowMeta: {
      isSelected: boolean;
    };
  };
}

const HotelSettingsCentralMappingTablesCellsTdMapping: TOC<HotelSettingsCentralMappingTablesCellsTdMappingSignature> =
  <template>
    <div data-test-id="table-central-mapping-td-mapping">
      <SettingsCentralMappingDropdownsDropdownMapping
        @autoCategory={{@row.mappingEntry.autoCategory}}
        @category={{@row.mappingEntry.category}}
        @hierarchyCategories={{@column.hierarchyCategories}}
        @isReadOnly={{or @column.isReadOnly @rowMeta.isSelected}}
        @isSelected={{@rowMeta.isSelected}}
        @onOverrideAutomapping={{@row.onOverrideAutomapping}}
        @setCategory={{@row.setCategory}}
        @toggleAutomapping={{@row.toggleAutomapping}}
        @userCategory={{@row.mappingEntry.userCategory}}
        @variant={{TRIGGER_CENTRAL_MAPPING_VARIANTS.SUBDUED}}
      />
    </div>
  </template>;

export default HotelSettingsCentralMappingTablesCellsTdMapping;
